import { AboutUSData } from '@/api/center/about-us/type'
import { Base, Component, Prop } from '@/vue-property-decorator'
import { CommonSwitchStatus } from '@/api/common/type'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { GameMenuActionHandler } from '@/views/game/classes'
import { NoticeType } from '@/views/notice/const'
import { RouteName } from '@/router/config'
import { TranslateResult } from 'vue-i18n'
import { useAboutUsStore } from '@/views/center/about-us/store'
import { useFooterStore } from '../../store'
import { useGameStore } from '@/views/game/store'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import { useTaskPageStore } from '@/views/task/store/taskPageStore'
import AppTypes from '@/vue-types'
import LinkResource from './linkResource'
import style from './style.module.scss'

const GameSwitch = 'gameSwitch'
interface ItemType {
  title: TranslateResult
  value: string
  to?: {
    name: string
    query?: Record<string, string | (string | null)[] | null | undefined>
  }
  disable?: boolean
  onClick?: () => void
}
interface ItemListType {
  title: TranslateResult
  value: string
  list: ItemType[]
  index: number
}

// 按照设计图排序
export const sortMap = {
  RecreationCity: 'recreationCity',
  Game: 'game',
  Support: 'support',
  QuickLogin: 'quickLogin',
  AboutUs: 'aboutUs',
  Other: 'other'
}
enum listSort {
  RecreationCity = 1,
  Game = 2,
  Support = 3,
  QuickLogin = 4,
  AboutUs = 5,
  Other = 6
}

export type Props = {
  layoutType: 'vertical' | 'horizontal'
  filterArr: Array<string>
  isNeedSeparateAboutUs: boolean
}

// 对应美术欧美版
@Component<LinkList>({ name: 'LinkList' })
export default class LinkList extends Base {
  @Prop(AppTypes.string.def('horizontal'))
  private readonly layoutType!: string

  @Prop(AppTypes.array.def([]))
  private readonly filterArr!: Array<string>

  @Prop(AppTypes.bool.def(true))
  private readonly isNeedSeparateAboutUs!: boolean

  store = useFooterStore()
  private get footerInfos() {
    return this.store.footerInfos
  }

  // 两个key需要特殊处理，新增canReveive原来奖励指向待领取（后台返回字段await不变）
  private findKey(sub: string) {
    const { t } = useI18n()
    if (sub === 'E-Sports') {
      return t('lobby.footer.quickJump.eSports')
    } else if (sub === 'award') {
      return t('lobby.footer.quickJump.canRecive')
    } else {
      return t(`lobby.footer.quickJump.${sub}`)
    }
  }

  private get linkList() {
    const { t } = useI18n()
    const { getActivesAuthInfos, getReturnGoldIsHide } = useMainStore()
    if (this.footerInfos?.quickJump) {
      const data: ItemListType[] = []
      const quickJumpData = [
        {
          value: 'providentFund',
          to: {
            name: RouteName.RECHARGE_FUND
          },
          disable: useMainStore().getRechargeFundIsHide
        },
        {
          value: 'active',
          to: {
            name: RouteName.EVENT
          },
          disable: !getActivesAuthInfos.activeCount
        },
        {
          value: 'task',
          to: {
            name: RouteName.TASK
          },
          onClick: () => useTaskPageStore().gotoTaskPage(),
          disable: !useTaskPageStore().isShowTaskPageEntrance
        },
        {
          value: 'backwater',
          to: {
            name: RouteName.CASHBACK
          },
          disable: getReturnGoldIsHide
        },
        {
          value: 'award',
          to: {
            name: RouteName.CANRECEIVE
          }
        },
        {
          value: 'vip',
          to: {
            name: RouteName.VIP
          },
          disable: useMainStore().getVipSwitchIsHide
        },
        {
          value: 'paidToPromote',
          to: {
            name: RouteName.PROMOTE
          }
        },
        {
          value: 'gameSwitch'
        },
        {
          value: 'onlineSupport',
          onClick: () =>
            this.$router.push({
              name: RouteName.NOTICE,
              query: {
                noticeType: `${NoticeType.SERVICE}`
              }
            })
        },
        {
          value: 'helpCenter',
          onClick: () => {
            this.$router.push({
              name: RouteName.NOTICE,
              query: {
                noticeType: `${NoticeType.SERVICE}`
              }
            })
          }
        },
        {
          value: 'prizeFeedback',
          onClick: () => {
            this.$router.push({
              name: RouteName.NOTICE,
              query: {
                noticeType: `${NoticeType.FEEDBACK}`
              }
            })
          }
        },
        {
          value: 'aboutUsSub',
          to: {
            name: RouteName.ABOUT_US
          }
        },
        {
          value: 'providentFund',
          to: {
            name: RouteName.RECHARGE_FUND
          },
          disable: useMainStore().getRechargeFundIsHide
        }
      ]

      // 按照设计图排序
      const enums = new Map([
        [sortMap.RecreationCity, listSort.RecreationCity],
        [sortMap.Game, listSort.Game],
        [sortMap.Support, listSort.Support],
        [sortMap.QuickLogin, listSort.QuickLogin],
        [sortMap.AboutUs, listSort.AboutUs],
        [sortMap.Other, listSort.Other]
      ])
      const { gameMenuAvailable, gameCategoriesAvailable } = useGameStore()
      const quickJump = Object.values(this.footerInfos.quickJump)
      quickJump?.sort((a, b) => {
        const indexA = this.filterArr.indexOf(a.value)
        const indexB = this.filterArr.indexOf(b.value)
        return indexA - indexB
      })
      //循环接口返回的配置list，包括游戏、娱乐城、快捷、支持等
      quickJump.forEach((item) => {
        const subItems: ItemType[] = []
        item.child.forEach((sub) => {
          //后台会返回gameSwitch和其他游戏类别，只需要取gameSwitch开关
          if (item.value === 'game' && item.child.includes(GameSwitch)) {
            sub === GameSwitch &&
              gameMenuAvailable.forEach((gameItem) => {
                gameItem.gameCategoryId !== GameCategoryIds.Hot &&
                  subItems.push({
                    title: gameItem.gameCategoryName,
                    value: '',
                    to: {
                      name: RouteName.GAME,
                      query: {
                        gameCategoryId:
                          gameItem.gameCategoryId as unknown as string
                      }
                    }
                  })
              })
            return
          }
          //兼容页脚上线前没有GameSwitch情况
          if (item.value === 'game' && !item.child.includes(GameSwitch)) {
            const current = quickJumpData.find((jump) => jump.value === sub)
            const isShow = gameCategoriesAvailable.find(
              (menu) =>
                menu.gameCategoryId.toString() ===
                current?.to?.query?.gameCategoryId
            )
            if (isShow || !!!current?.to?.query?.gameCategoryId) {
              subItems.push({
                title:
                  sub === 'E-Sports'
                    ? t('lobby.footer.quickJump.eSports')
                    : t(`lobby.footer.quickJump.${sub}`),
                value: sub,
                to: current?.to,
                onClick: current?.onClick,
                disable: current?.disable ?? false
              })
            }
            return
          }
          // //在上面枚举的配置里面，找到跟后台返回对应的一项
          const current = quickJumpData.find((jump) => jump.value === sub)
          subItems.push({
            title: this.findKey(sub),
            value: sub,
            to: current?.to,
            onClick: current?.onClick,
            disable: current?.disable ?? false
          })
        })
        data.push({
          title: t(`lobby.footer.quickJump.${item.value}`),
          value: item.value,
          list: subItems,
          index: Number(enums.get(item.value))
        })
      })
      return data
        .filter((data) => this.filterArr.includes(data.value))
        .sort((a, b) => a['index'] - b['index'])
    }
    return []
  }

  private lintJump(subItem: ItemType) {
    const { onClick, disable } = subItem
    if (!!disable) {
      return
    }
    if (onClick) {
      onClick()
      return
    }
    if (subItem.to?.name === RouteName.GAME) {
      if (LinkResource.isToSubPage) {
        GameMenuActionHandler.jumpToSubGameFromMenu(
          Number(subItem?.to?.query?.gameCategoryId)
        )
      } else {
        GameMenuActionHandler.scrollMenuToGameCategory(
          Number(subItem?.to?.query?.gameCategoryId)
        )
      }
      return
    }
    this.$router.push({
      name: subItem?.to?.name,
      query: subItem?.to?.query
    })
  }

  private aboutItemFn(item: AboutUSData) {
    return (
      <div
        class={{
          [style.item]: true,
          'link-list-item': true,
          'sub-item': true
        }}
        onClick={() => {
          this.$router.push({
            name: RouteName.ABOUT_US,
            query: {
              current: String(item.id)
            }
          })
        }}
      >
        {item.title?.slice(0, 9)}
      </div>
    )
  }

  private rendeAboutUsList() {
    const { aboutUsList } = useAboutUsStore()
    return (
      <div class={style.aboutUsBox}>
        {aboutUsList.map((item) => this.aboutItemFn(item))}
      </div>
    )
  }

  // 判断当前后台配置里面是否有简介（关于我们）
  get hasAboutUs() {
    return this.linkList.find((item) => item.value === sortMap.AboutUs)
  }

  private aboutUs(item: ItemListType) {
    //1、当前是渲染到支持的item
    //2、关于我们不需要单独成列渲染
    //3、后台有配置关于我们

    if (this.showAboutUs(item)) {
      return this.rendeAboutUsList()
    }
  }

  /**兼容旧数据 quickJuml=>aboutUs=>child 或者 quickJuml=>support=>child*/
  private showAboutUs(item: ItemListType) {
    const { brandLogoInfos } = useMainStore()
    return (
      item.value === sortMap.Support &&
      (item?.list?.find((item) => item.value === 'aboutUsSub') ||
        this.footerInfos?.quickJump?.aboutUs?.child?.includes('aboutUsSub')) &&
      !this.isNeedSeparateAboutUs &&
      brandLogoInfos?.aboutUsStatus == CommonSwitchStatus.OPEN
    )
  }

  render() {
    const { aboutUsList } = useAboutUsStore()
    if (this.footerInfos?.quickJumpStatus) {
      return <template></template>
    }
    if (this.layoutType === 'vertical') {
      //竖型排版
      return (
        <div class={[style.verticalBox, 'vertival-box']}>
          {this.linkList.map((item) => {
            return (
              <div class={style.itemBox}>
                <div class={[style.title, 'link-list-title']}>{item.title}</div>
                <div class={style.itemList}>
                  {item.list.map((subItem) => {
                    const { value, title, disable } = subItem
                    if (value === 'aboutUsSub') {
                      return
                    }
                    return (
                      <div
                        class={{
                          [style.item]: true,
                          'link-list-item': true,
                          [style.disable]: disable ?? false
                        }}
                        onClick={() => {
                          this.lintJump(subItem)
                        }}
                      >
                        {title}
                      </div>
                    )
                  })}
                  {this.aboutUs(item)}
                </div>
              </div>
            )
          })}
        </div>
      )
    } else {
      //横型排版
      return (
        <div class={[style.horizontalBox, 'horizontal-box']}>
          {this.linkList.map((item) => {
            return (
              <div class={style.itemBox}>
                <div class={[style.itemTitle, 'item-title']}>{item.title}</div>
                <div class={style.itemList}>
                  {item.list.map((subItem) => {
                    const { value, title, disable } = subItem
                    //支持下面配置了关于我们，并且关于我们不需要单独一排渲染，则当前这个关于我们不渲染
                    if (value === 'aboutUsSub' && !this.isNeedSeparateAboutUs) {
                      return false
                    }
                    //支持下面配置了关于我们，并且关于我们需要单独一排渲染，则当前这个item用关于我们列表来渲染
                    if (value === 'aboutUsSub' && this.isNeedSeparateAboutUs) {
                      return this.rendeAboutUsList()
                    }
                    return (
                      <div
                        class={{
                          [style.item]: true,
                          'sub-item': true,
                          [style.disable]: disable ?? false
                        }}
                        onClick={() => {
                          this.lintJump(subItem)
                        }}
                      >
                        {title}
                      </div>
                    )
                  })}
                  {this.showAboutUs(item) &&
                    aboutUsList.map((aboutusItem) =>
                      this.aboutItemFn(aboutusItem)
                    )}
                </div>
              </div>
            )
          })}
        </div>
      )
    }
  }
}
